export const breakpoints = {
    mobile: 320,
    tablet: 641,
    desktop: 769,
    large: 1007
};

export default breakpoints;
